import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      lighter: '#e6f7f5', // Add lighter shade for hover states
      main: '#358c7c', // Updated primary color
      light: '#4aa090',
      dark: '#2a7062',
    },
    secondary: {
      lighter: '#f4f6e8', // Add lighter shade for hover states
      main: '#9dad4c', // Updated secondary color
      light: '#b3c157',
      dark: '#7d8a3c',
    },
    // Adding new fruity theme colors
    fruity: {
      seafoamGreen: '#E0E8E2',
      salmon: '#FFA384',
      white: '#F3F3F3',
      carafe: '#7A3C3A',
    },
    mermaid: {
      midnightBlue: '#145DA0',
      darkBlue: '#0C2D48',
      blue: '#2E8BC0',
      babyBlue: '#B1D4E0',
    },
    padlocked: {
      mauve: '#B99095',
      salmon: '#FCB5AC',
      mint: '#B5E5CF',
      tealGreen: '#3D5B59',
    },
    waterFoam: {
      mint: '#DDFFE7',
      spearmint: '#98D7C2',
      tealGreen: '#167D7F',
      teal: '#29A0B1',
    },
    afternoonSinkers: {
      rosewater: '#FFC2C7',
      spearmint: '#B6E5D8',
      peach: '#FBE5C8',
      turquoise: '#8FDDE7',
    },
    roseWater:{
      rosewater: '#E8B4B8',
      dustyrose: '#EED6D3',
      coffeepot: '#A49393',
      coffepotdark: '#67595E',

    },
    bubblyBanana:{
      bluegreen: '#15B5B0',
      rosewater: '#F9BDC0',
      champagne: '#FBE698',
      cyan: '#6DECE0',

    },
    pickedOranges:{
      taupe: '#ADA7A7',
      pewter: '#D3D3CB',
      orange: '#D375O6',
      redorange: '#9F2B00',

    },

    optional: {
      lighter: '#e8efef', // Add lighter shade for hover states
      main: '#12403d', // Optional color
      light: '#1a5652',
      dark: '#0d2e2c',
    },
    background: {
      default: '#F9FAFB',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#12403d', // Using optional color for text
      secondary: '#5c6b6a',
    },
    divider: '#e6e8eb',
  },
  typography: {
    fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 700,
    },
    h3: {
      fontWeight: 600,
    },
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 500,
    },
    h6: {
      fontWeight: 500,
    },
    button: {
      fontWeight: 500,
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          padding: '10px 22px',
          fontSize: '0.875rem',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        contained: {
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            '& fieldset': {
              borderColor: ({ theme }) => theme.palette.primary.main + '40',
            },
            '&:hover fieldset': {
              borderColor: ({ theme }) => theme.palette.primary.main,
            },
            '&.Mui-focused fieldset': {
              borderColor: ({ theme }) => theme.palette.primary.main,
            },
            '&:-webkit-autofill': {
              // WebkitBoxShadow: '0 0 0 100px #ffffff inset',
              // WebkitTextFillColor: ({ theme }) => theme.palette.text.primary,
              WebkitBoxShadow: 'none',
              // transition: 'background-color 9999s ease-out 0s',
              // WebkitTextFillColor: ({ theme }) => theme.palette.text.primary
            },
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: ({ theme }) => theme.palette.text.secondary,
          '&.Mui-checked': {
            color: ({ theme }) => theme.palette.primary.main,
          },
         
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: ({ theme }) => theme.palette.text.secondary,
          '&.Mui-checked': {
            color: ({ theme }) => theme.palette.primary.main,
          },
        
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          '&:hover': {
            color: ({ theme }) => theme.palette.primary.main,
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        }
      }
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          minHeight: '64px !important',
          padding: '0 24px !important'
        }
      }
    },
  },
});

export default theme;
